import apiClient from './apiClient';

export interface QueryParams {
  deptFrom?: string;
  deptTo?: string;
  sortBy?: string;
}

export interface EmployeeRow {
  emp_no: string;
  emp_name: string;
  dept_code: string;
  dept_name: string;
  title_code: string;
  title_name: string;
  hire_date: string;
  seniority: number;
}

export interface QueryResponse {
  data: EmployeeRow[];
  count: number;
  message?: string;
}

export const pw9403Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9403/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw9403/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
